// extracted by mini-css-extract-plugin
export default {"markdown":"SummaryViewer_markdown__2vDsA","summaryContainer":"SummaryViewer_summaryContainer__AD3cm"};